import React from 'react'

const TermsAndCondition = () => {
    return (
        <>
            <section className="inner-banner">
                <div className="container-fluid web-padding">
                    <div className="row">
                        <div className="col-md-6" data-aos="fade-right" data-aos-duration={1000}>
                            <div className="inner-banner-left">
                                <h1>Terms & Conditions</h1>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="inner-banner-right">
                                <img src="images/hero-tires.png" alt="img" />
                            </div>
                        </div>
                    </div>
                </div>
                <h2>Tyres</h2>
            </section>
            <section className='website_policy_sec'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <h2>1. Introduction</h2>
                            <p> Welcome to MV Tyres. By accessing or using our website, products, or services, you agree to be bound by these Terms & Conditions. Please read them carefully before using our services.</p>
                            <h2>2. Services</h2>
                            <p> MV Tyres provides tyre sales, fitting, mobile fitting, emergency call-outs, fleet support, and wholesale supply. All services are subject to availability. Prices may change without prior notice.</p>
                            <h2>3. Bookings & Payments</h2>
                            <ul>
                                <li>Bookings can be made online, by phone, or in person.</li>
                                <li>Payments must be made in full upon completion of service, unless otherwise agreed in writing.</li>
                                <li>For wholesale or business accounts, payment terms will be agreed separately.</li>
                            </ul>
                            <h2>4. Cancellations & Refunds</h2>
                            <ul>
                                <li>Cancellations must be made at least 24 hours before the scheduled appointment.</li>
                                <li>Refunds are only issued if the product or service has not been provided, or if required by law.</li>
                                <li>Fitted tyres cannot be refunded unless proven faulty.</li>
                            </ul>
                            <h2>5. Liability</h2>
                            <ul>
                                <li>MV Tyres will take all reasonable care when fitting or supplying tyres.</li>
                                <li>We are not liable for indirect losses, delays, or issues caused by factors beyond our control (e.g., weather, traffic, supplier delays).</li>
                                <li>Customers are responsible for ensuring their vehicle is in a safe condition for tyre fitting.</li>
                            </ul>
                            <h2>6. Warranties</h2>
                            <p> All tyres supplied are covered by the manufacturer’s warranty. This does not cover damage caused by misuse, neglect, or road hazards.</p>
                            <h2>7. Governing Law</h2>
                            <p> These Terms & Conditions are governed by the laws of Scotland and the United Kingdom.</p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default TermsAndCondition